import React, { useContext, useState } from "react"

interface AppValue {
  version: number,
  CURRENT_VERSION: number,
  updateVersion: (version: number) => void,
  checkVersion:()=>Boolean
}

const AppContext = React.createContext<AppValue | null>(null);

export function useAppContext() {
  return useContext(AppContext)
}

export const AppProvider: React.FC = ({ children }) => {
  const CURRENT_VERSION = 1.9
  const [version, setVersion] = useState(CURRENT_VERSION);

  function updateVersion(version: number) {
    setVersion(version)
  }

  function checkVersion() {
    return CURRENT_VERSION === version
  }

  const value = {
    version,
    CURRENT_VERSION,
    updateVersion,
    checkVersion
  }

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  )
}